import { render, staticRenderFns } from "./action-sort.vue?vue&type=template&id=5d1eaa6b&"
import script from "./action-sort.vue?vue&type=script&lang=js&"
export * from "./action-sort.vue?vue&type=script&lang=js&"
import style0 from "./action-sort.vue?vue&type=style&index=0&id=5d1eaa6b&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports